import { Component, OnInit } from '@angular/core';
import {DocumentsKeyEnum} from "../../../../../../shared/legal-documents/src/lib/legal-documents.service";
import {ActivatedRoute, Router} from "@angular/router";
import {
  AccountCreationSteps,
  FinancialAccountsCreationService
} from "@brightside-web/desktop/feature/financial-accounts-core";

@Component({
    selector: 'brightside-web-savings-account-consents',
    templateUrl: './savings-account-consents.component.html',
    styleUrls: ['./savings-account-consents.component.scss'],
    standalone: false
})
export class SavingsAccountConsentsComponent implements OnInit {

  documentsKey = DocumentsKeyEnum.SAVINGS_ACCOUNT;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private faCreateSvc: FinancialAccountsCreationService
  ) { }

  ngOnInit(): void {
  }

  termsAccepted($event: boolean) {
    if ($event) {
      this.faCreateSvc.advanceStep(AccountCreationSteps.CONSENTS);
      this.router.navigate(['../create'], {relativeTo: this.route});
    }
  }
}
